import {Week} from "./week.model";
import * as firebase from 'firebase/app';
import * as moment from 'moment';

export class Day {
  weekNumber? : number;
  weekCode : string;
  day: any;
  dayYMD? : string;
  dayMDY? : string;
  dayShort? : string;
  dayLong? : string;
  dayData? : object;
  loaded? : boolean = false;
  loading? : boolean = false;
  week: Week;
  foods? = {
    arr : [],
    obj : {}
  };
  active? :boolean = false;
  charge? = {
    exists : false,
    data : [],
    filtered: [],
    properties: {
      history : []
    }
  };

  constructor(day,week,weekCode,active){
    this.weekNumber = moment(day).week();
    this.weekCode = weekCode;
    this.dayYMD = day.format('YYYYMMDD'),
    this.dayMDY = day.format('MM-DD-YYYY'),
    this.dayShort = day.format("dd"),
    console.log('🌟 -> file: day.model.ts:37 -> Day -> constructor -> dayShort', this.dayShort)
    this.dayLong = day.format("dddd"),
    this.dayData = {
      y : day.format('YYYY'),
      m : day.format('MMMM'),
      d : day.format('D')
    };
    this.week = week;
    console.log("day constructor!", this.dayYMD);
    firebase.firestore().collection('orders').doc(this.dayYMD)
      .get().then((snap)=>{
      this.charge.exists = snap.exists;
      if(snap.exists){
        console.log("loading charge",this.dayYMD);
        this.charge.properties.history = snap.data()['history'];
      }
    })
  }

  load?(){
    return new Promise((resolve, reject) => {
      firebase.firestore().collection('orders').doc(this.dayYMD).collection('data')
        // .where('shipping.delivered','==',true)
        .get().then((snap)=> {
        if(!snap.empty){
          this.charge.data = [];
          snap.forEach((x)=>{
            this.charge.data.push(x.data());
          })
          this.loaded = true;
          this.loading = false;
          resolve(true);
        }
      })
    })
  }

  filterDay?(){
    this.foods.obj = {};
    this.foods.arr = [];
    this.week.data.map((f)=>{
      this.foods.obj[f.value] = {
        family: f.family,
        name: f.name,
        value: f.value,
        prod : []
      };
      const pr = f.days.filter((d)=>{
        return d.name===this.dayShort.replace('á', 'a');
      });
      if(pr.length) this.foods.obj[f.value].prod = pr[0].prods;
    });
    this.foods.arr = Object.keys(this.foods.obj);
  }
}


export class DayMaker {
  static create(event: Day) {
    return new Day(event.day,event.week, event.weekCode, event.active);
  }
}





// WEBPACK FOOTER //
// ./src/models/day.model.ts